// === blocks/_pivot-cart-drawer.liquid ===
class PivotCartDrawerSidebar extends HTMLElement {
  connectedCallback() {
    // super();
    this.$suggestions = this.querySelector('pivot-suggestions-drawer');

    this.desktopPosition = this.$suggestions?.getAttribute('desktop-position');
    this.mobilePosition = this.$suggestions?.getAttribute('mobile-position');

    this.setPosition();
    window.addEventListener('resize', this.setPosition);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.setPosition);
    this.mutationObserver?.disconnect();
  }
  setPosition = () => {
    const isMobile = window.innerWidth < 750;
    const position = isMobile ? this.mobilePosition : this.desktopPosition;

    if (position === this.currentPosition) return;
    this.currentPosition = position;

    this.mutationObserver?.disconnect();
    this.$lineItemsWrapper?.querySelector('pivot-suggestions-drawer')?.remove();

    switch (position) {
      case 'below_line_items':
        this.observer('.cart-drawer__content .cart-drawer__items', 'beforeend');
        break;
      case 'above_footer':
        this.observer('.cart-drawer__content .cart-drawer__summary', 'afterbegin');
        break;
    }
  };
  observer(selector, position) {
    this.$lineItemsWrapper = document.querySelector(selector);
    if (!this.$lineItemsWrapper) return;

    this.mutationObserver = new MutationObserver(() => {
      const child = this.$lineItemsWrapper.querySelector('pivot-suggestions-drawer');
      if (child) return;

      this.$lineItemsWrapper.insertAdjacentHTML(position, this.innerHTML);
    });

    this.mutationObserver.observe(this.$lineItemsWrapper, {
      childList: true,
    });

    this.$lineItemsWrapper.insertAdjacentHTML(position, this.innerHTML);
  }
}
if (!customElements.get('pivot-cart-drawer-sidebar')) {
  customElements.define('pivot-cart-drawer-sidebar', PivotCartDrawerSidebar);
}
